module.exports = __webpack_public_path__ + "static/media/Desktop-Banner-Client-Scheduler.4ab36b16.jpg";